export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/decor-airport.84795a14-f60ef2.svg";